<template>
  <expandable header="Liver Function Test (LFT)" class="mb-10">
    <b-row>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.lft_total_bilirubin"
          label="Total Bilirubin"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.lft_direct_bilirubin"
          label="Direct Bilirubin"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.lft_indirect_bilirubin"
          label="Indirect Bilirubin"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.lft_sgot"
          label="SGOT"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.lft_sgpt"
          label="SGPT"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.lft_total_protein"
          label="Total Protein"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.lft_albumin"
          label="Albumin"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.lft_globulin"
          label="Globulin"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.lft_ag_ratio"
          label="A/G Ratio"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.lft_alp"
          label="ALP"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.lft_ggt"
          label="GGT"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.lft_inr"
          label="INR"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
      <b-col cols="12" md="4">
        <input-field
          v-model.trim="form.lft_ldh"
          label="LDH"
          :disabled="isDisabled"
          @input="onInput"
        ></input-field>
      </b-col>
    </b-row>
  </expandable>
</template>

<script>
import Expandable from "../../Expandable.vue";
import InputField from "../../form/InputField.vue";

export default {
  components: { Expandable, InputField },
  props: {
    value: {},
    isDisabled: { default: false, type: Boolean },
  },
  data() {
    return { form: {} };
  },
  methods: {
    onInput() {
      this.$emit("input", this.form);
    },
  },
  beforeMount() {
    this.form = this.value;
  },
  mounted() {
    this.onInput();
  },
};
</script>
